import { CmsApiSupportContactFormBlockData } from 'modules/cms/api/types/CmsApiSupportContactForm';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpSupportContactFormBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiSupportContactFormBlockData>) {
  const text = getText('Need Help?');
  const buttonText = getText('Contact Us');

  return (
    <CmsAmpHeroBlock
      content={content}
      // @ts-expect-error Fix me
      data={{ ...data, text, buttonText }}
      blockId={blockId}
    />
  );
}
